/**
 * Interceptor simple para suprimir errores de conexión en la consola
 * cuando el backend no está disponible
 */

// Interceptar errores de consola para suprimir los de conexión
const originalConsoleError = console.error;

console.error = (...args) => {
  const message = args[0];
  
  // Suprimir errores específicos de conexión
  if (typeof message === 'string') {
    if (
      message.includes('ERR_CONNECTION_REFUSED') ||
      message.includes('Failed to load') ||
      message.includes('WebSocket connection failed') ||
      message.includes('NetworkError') ||
      message.includes('Failed to fetch') ||
      message.includes('Load failed')
    ) {
      // Solo loguear en modo desarrollo
      if (process.env.NODE_ENV === 'development') {
        console.warn('[ErrorInterceptor] Conexión fallida suprimida:', message);
      }
      return;
    }
  }
  
  // Para otros errores, usar el console.error original
  originalConsoleError.apply(console, args);
};

export default {};
